module.exports = __webpack_public_path__ + "5e367d8d5ce02c2ba02e5e0f466a0d98.png";